import axios from 'axios';
import { getCookie } from './cookies';

// Create an axios instance
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE,
    withCredentials: true, // Important for sending cookies
});

// Add CSRF token automatically to every request
axiosInstance.interceptors.request.use((config) => {
    const token = getCookie('csrfToken');
    if (token) {
        config.headers['X-CSRF-Token'] = token;
    }
    return config;
});

export default axiosInstance;

